import { useCallback } from 'react';
import { useTemplateEditorDispatch } from '../context/UseTemplateEditorContext';

export const useSaveChanges = () => {
  const dispatch = useTemplateEditorDispatch();
  return useCallback(() => {
    dispatch({
      type: 'SET_EDITING_DONE',
      payload: {
        editingDone: true,
      },
    });
  }, [dispatch]);
};
